import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import recordReducer from './slices/recordSlice';
import uiReducer from './slices/uiSlice';
import dashboardReducer from './slices/dashboardSlice';
import membersReducer from './slices/membersSlice';
import messagingReducer from './slices/messagingSlice';
import templatesReducer from './slices/templatesSlice';
import settingsReducer from './slices/settingsSlice';
import usersReducer from './slices/usersSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    records: recordReducer,
    ui: uiReducer,
    dashboard: dashboardReducer,
    members: membersReducer,
    messaging: messagingReducer,
    templates: templatesReducer,
    settings: settingsReducer,
    users: usersReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
